import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Extend Window interface for TypeScript
declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

/**
 * Tracks SPA page views for Google Tag Manager
 * Pushes virtualPageview events to dataLayer on route changes
 */
export function GTMPageViewTracker() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip first render - GTM already captures initial page load
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // Push virtual pageview to dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'virtualPageview',
      page: {
        path: location.pathname,
        search: location.search,
        hash: location.hash,
        url: window.location.href,
        title: document.title,
      }
    });

  }, [location.pathname, location.search]);

  return null;
}
